import React, { Component } from 'react'

export default class BarChartSkeleton extends Component {
    state = {
        bars: [
            { height: "100px", bg: "#dedede", right: "50px" },
            { height: "170px", bg: "#dedede", right: "121px" },
            { height: "20px", bg: "#dedede", right: "192px" },
            { height: "48px", bg: "#dedede", right: "270px" },
            { height: "110px", bg: "#dedede", right: "340px" },
        ]
    }
    render() {
        return (
            <div className="dashboard-widgets p-3 position-relative" >

                <div >
                    <div className='br-15 mt-1' style={{ width: '20%', height: 18, backgroundColor: '#dedede' }}></div>
                    <div className='br-15 mt-2' style={{ width: '100%', height: 18, backgroundColor: '#dedede' }}></div>

                    <div className=' ' style={{}}>

                        {this.state.bars.map((item, index) => {
                            return (
                                <div key={index} className='position-absolute skeleton-box' style={{ width: 60, height: (item.height), backgroundColor: (item.bg), borderRadius: 3, bottom: 16, right: (item.right) }}></div>
                            )
                        })}


                        <div className='position-absolute' style={{ width: '90%', height: 2, backgroundColor: '#dedede', bottom: 16, right: 15 }}></div>
                        <div className='position-absolute  br-5' style={{ width: 2.5, height: 197, backgroundColor: '#dedede', right: 15, bottom: 17, }}></div>




                    </div>

                </div>

            </div >
        )
    }
}
